import {CreateOperationalEntityInputV2} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResultNode} from "../view-model";

export const toQueuedResults = (
  input: CreateOperationalEntityInputV2
): CreateResultNode => {
  return {
    status: "queued",
    oeId: "",
    caId: input.sources[0].sourceId,
    dbaName: input.organizationInformation.dbaName,
    children: input.children?.map(toQueuedResults) || []
  };
};
